import { CollectionDTOInterface } from '@thewhite/react-global-module/lib/interfaces';
import { UtilService } from '@thewhite/react-global-module/lib/services';
import { action, IObservableValue, observable } from 'mobx';
import { UserControllerActions } from '../../User/actions/userControllerActions';
import User from '../../User/models/user';

export class UserStore {
    @observable userList: IObservableValue<User[]>;
    @observable fullUserSaveList: User[];

    constructor() {
        this.userList = observable.box<User[]>([]);
        this.fullUserSaveList = [];
    }

    /**
     * Получить пользователей
     */
    @action('get users')
    getUsers = (): any[] => {
        return this.userList.get();
    };

    /**
     * Сохранить пользователей
     */
    @action('set users')
    setUsers = (users: User[]): void => {
        this.userList.set(users);
    };

    @action('add full user')
    addFullUser = (ids: string[]): Promise<any> => {
        let array = ids.filter(el => !this.fullUserSaveList || this.fullUserSaveList.findIndex((child: User) => child.id === el) === -1);
        if (!array.length) {
            return Promise.resolve({});
        }
        return UserControllerActions.page({
            queryParams: {
                pageNo: 0,
                pageSize: UtilService.getUniqElementsByArray(array).length,
            },
            bodyParams: {
                ids: UtilService.getUniqElementsByArray(array),
            },
        })
            .then((res: CollectionDTOInterface<User>) => this.fullUserSaveList = this.fullUserSaveList.length ? this.fullUserSaveList.concat(res.items) : res.items);
    };

    /**
     * Получить запись справочника имея только id (работаем с юзерами, а не с профилями)
     */
    getEntityByIdByFullList(id: string): User | null {
        if (!this.fullUserSaveList.length) {
            return null;
        }
        let index = this.fullUserSaveList.findIndex((el: User) => el.id === id);
        if (index === -1) {
            return null;
        }
        return this.fullUserSaveList[index];
    }

    /**
     * Получить имя записи справочника имея только id (работаем с юзерами, а не с профилями)
     */
    getNameByIdByFullList(id: string, full: boolean = false, notAnonymous: boolean = false): string {
        let entity: User | null = this.getEntityByIdByFullList(id);
        return entity && entity.profile && entity.profile.personality ? UtilService.concatPersonName(entity.profile.personality, full) : (notAnonymous ? '' : 'Анонимный пользователь');
    }
}

const userStore = new UserStore();

export default userStore;
